<template>
  <div id="panoContainer" class="v-pano"></div>
</template>

<script>
import * as PANOLENS from "panolens";
import * as THREE from "three";

let viewer;

export default {
  name: "Pano",
  props: {
    source: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    onMouseMove(e){
      let vector = new THREE.Vector3();
      vector.set((e.clientX / window.innerWidth) * 2 - 1, -(e.clientY / window.innerHeight) * 2 + 1,0);
      vector.unproject(this.$LAT.camera);
      this.$LAT.mouseVector = vector;
    },
    reportLoadingPanoramaDone() {
      //standart
      this.$LAT.lookAtObject(new THREE.Vector3(5000, -500, 0));
      this.$emit("loadingDone", false);
      this.$LAT.cockpit.screens.forEach(screen => {
        screen.on("click", () => {
          this.$emit("screenSwitch", {value: true, procedure: null});
        });
      })
    }
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.onMouseMove)
  },
  mounted() {
    this.$LAT.initPanorama(this.$el).then(()=>{
      this.$LAT.scene.addEventListener("progress", ({progress})=>{
        if(progress.loaded === progress.total){
          this.reportLoadingPanoramaDone();
        }
      });
    });
    this.onMouseMove.bind(this);
    document.addEventListener('mousemove', this.onMouseMove)
  }
};
</script>

<style lang="less">
.v-pano {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  overflow: hidden;
}
html,
body {
  width: 100%;
  height: 100%;
}
</style>
